var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgTt = function SvgTt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h640v480H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M463.663 480L.05 1.003 0 479.747l463.663.253zM176.337 0L639.95 478.997 640 .253 176.337 0z",
    fillRule: "evenodd",
    fill: "#e00000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.74.23h118.597l468.176 479.315h-122.35L27.738.229z",
    fillRule: "evenodd"
  })));
};
export default __webpack_public_path__ + "assets/95ffe73e78251c9de8817c31b846c524.svg";
export { SvgTt as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/tt.svg